import React from "react";
import { LuMousePointerClick } from "react-icons/lu";
import { Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useSendEvent from "hooks/useSendEvent";
import { checkRemainingDays } from "utils/formateDate";

const Card = ({ item }) => {
  const { sendEvent } = useSendEvent();
  const navigate = useNavigate();

  const start_date =
    item?.course?.course_start_date &&
    checkRemainingDays(item?.course?.course_start_date);

  const convertEnglishToBangla = (value) => {
    if (typeof value === "string") {
      const UpdatedValue = value.replace("+", "");
      return Number(UpdatedValue).toLocaleString("bn");
    } else {
      return Number(value).toLocaleString("bn");
    }
  };

  const navigateDetails = (item) => {
    navigate(`/courseDetails/${item?.course?.id}`);
    sendEvent("বিস্তারিত", "home", item?.course?.id);
  };

  return (
    <div
      className="bg-white rounded-[13px] text-[#2C394B] border border-[#98A2B3] relative overflow-hidden col-span-1 flex flex-col cursor-pointer"
      onClick={() => navigateDetails(item)}
    >
      <div className="">
        <img
          src={item?.course?.thumbnail}
          alt="course-thumbnail"
          className="w-full h-auto md:h-[200px] object-cover"
        />
      </div>
      <div className="p-5 flex flex-col flex-grow">
        <div className="flex gap-2 items-center font-ador flex-wrap">
          {item?.course?.is_career_path ? (
            <div className="bg-[#D0D5DD80] flex items-center gap-2 rounded-[6px] px-2 py-[3px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
              >
                <path
                  d="M9.50067 8.04283C10.3543 8.04283 11.0463 7.35085 11.0463 6.49725C11.0463 5.64364 10.3543 4.95166 9.50067 4.95166C8.64706 4.95166 7.95508 5.64364 7.95508 6.49725C7.95508 7.35085 8.64706 8.04283 9.50067 8.04283Z"
                  stroke="#F72568"
                  stroke-miterlimit="10"
                />
                <path
                  d="M5.68066 10.3165C5.17835 9.81446 4.77987 9.2184 4.508 8.56235C4.23612 7.90629 4.09619 7.2031 4.09619 6.49294C4.09619 5.78279 4.23612 5.07959 4.508 4.42354C4.77987 3.76748 5.17835 3.17143 5.68066 2.66943"
                  stroke="#2C394B"
                  stroke-miterlimit="10"
                />
                <path
                  d="M13.3193 2.66943C13.8217 3.17143 14.2201 3.76748 14.492 4.42354C14.7639 5.07959 14.9038 5.78279 14.9038 6.49294C14.9038 7.2031 14.7639 7.90629 14.492 8.56235C14.2201 9.2184 13.8217 9.81446 13.3193 10.3165"
                  stroke="#2C394B"
                  stroke-miterlimit="10"
                />
                <path
                  d="M3.49565 12.5016C2.70464 11.7137 2.07699 10.7773 1.64873 9.74626C1.22046 8.7152 1 7.60971 1 6.49323C1 5.37676 1.22046 4.27127 1.64873 3.2402C2.07699 2.20914 2.70464 1.27278 3.49565 0.484863"
                  stroke="#2C394B"
                  stroke-miterlimit="10"
                />
                <path
                  d="M15.5039 0.484863C16.2949 1.27278 16.9226 2.20914 17.3508 3.2402C17.7791 4.27127 17.9996 5.37676 17.9996 6.49323C17.9996 7.60971 17.7791 8.7152 17.3508 9.74626C16.9226 10.7773 16.2949 11.7137 15.5039 12.5016"
                  stroke="#2C394B"
                  stroke-miterlimit="10"
                />
                <path
                  d="M9.4994 8.01831C10.1132 8.01831 10.7019 8.26214 11.1359 8.69616C11.5699 9.13019 11.8137 9.71885 11.8137 10.3326C11.815 12.3631 11.3441 14.3661 10.4381 16.1832L10.2681 16.515H8.73065L8.56072 16.1832C7.65471 14.3661 7.18375 12.3631 7.18506 10.3326C7.18506 10.0287 7.24492 9.72778 7.36123 9.44699C7.47754 9.1662 7.64801 8.91107 7.86291 8.69616C8.07782 8.48126 8.33295 8.31079 8.61374 8.19448C8.89453 8.07817 9.19547 8.01831 9.4994 8.01831Z"
                  stroke="#F72568"
                  stroke-miterlimit="10"
                />
              </svg>
              <span className="text-xs font-bold">লাইভ ক্লাস</span>
            </div>
          ) : (
            <div className="bg-[#D0D5DD80] flex items-center gap-2 rounded-[6px] px-2 py-[3px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
              >
                <path
                  d="M1 3.5C1 2.11929 2.11929 1 3.5 1H10.1667C11.5474 1 12.6667 2.11929 12.6667 3.5V10.1667C12.6667 11.5474 11.5474 12.6667 10.1667 12.6667H3.5C2.11929 12.6667 1 11.5474 1 10.1667V3.5Z"
                  stroke="#2C394B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.0002 4.3335V13.5002C16.0002 14.8809 14.8809 16.0002 13.5002 16.0002H4.3335"
                  stroke="#2C394B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.99976 8.49984V5.1665L8.61884 6.83317L5.99976 8.49984Z"
                  fill="#2C394B"
                  stroke="#2C394B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span className="text-xs font-bold">রেকর্ড ক্লাস</span>
            </div>
          )}

          {item?.course?.course_start_date && (
            <div className="bg-[#D0D5DD80] flex items-center gap-2 rounded-[6px] px-2 py-[3px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
              >
                <path
                  d="M3.125 13.75H11.875M3.125 1.25H11.875M10.625 13.75V11.1425C10.6249 10.811 10.4932 10.4931 10.2587 10.2587L7.5 7.5M7.5 7.5L4.74125 10.2587C4.50681 10.4931 4.37507 10.811 4.375 11.1425V13.75M7.5 7.5L4.74125 4.74125C4.50681 4.50688 4.37507 4.18899 4.375 3.8575V1.25M7.5 7.5L10.2587 4.74125C10.4932 4.50688 10.6249 4.18899 10.625 3.8575V1.25"
                  stroke="#2C394B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span className="text-xs font-bold">
                {convertEnglishToBangla(start_date)} - দিন বাকি
              </span>
            </div>
          )}
          {item?.course?.batch_no && (
            <div className="bg-[#D0D5DD80] flex items-center gap-2 rounded-[6px] px-2 py-[3px]">
              <span className="text-xs font-bold">
                ব্যাচ - {convertEnglishToBangla(item?.course?.batch_no)}
              </span>
            </div>
          )}
        </div>

        <div className="mt-3 flex flex-col justify-between h-full">
          <Divider />
          <h3 className="text-xl font-semibold hind-siliguri py-1">
            {item?.course?.title}
          </h3>
          <Divider />
        </div>

        <div className="mt-auto">
          {!!item?.total_enrolled && (
            <div className="flex items-center gap-2 mt-3 font-ador">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="15"
                viewBox="0 0 20 15"
                fill="none"
              >
                <path
                  d="M18.9853 5.4969V10.8928M4.59621 7.7452V10.8928C4.59621 11.6083 5.1647 12.2946 6.17663 12.8005C7.18856 13.3065 8.56102 13.5908 9.99211 13.5908C11.4232 13.5908 12.7957 13.3065 13.8076 12.8005C14.8195 12.2946 15.388 11.6083 15.388 10.8928V7.7452M18.4637 6.32607C18.6247 6.25505 18.7613 6.13836 18.8566 5.99045C18.9519 5.84255 19.0018 5.66992 19 5.49397C18.9981 5.31802 18.9447 5.14646 18.8464 5.00056C18.748 4.85465 18.609 4.74081 18.4466 4.67313L10.7385 1.1622C10.5042 1.05531 10.2497 1 9.99211 1C9.73455 1 9.48 1.05531 9.24567 1.1622L1.53853 4.66953C1.37842 4.73965 1.24222 4.85491 1.14658 5.00121C1.05094 5.14752 1 5.31852 1 5.49331C1 5.6681 1.05094 5.8391 1.14658 5.9854C1.24222 6.1317 1.37842 6.24696 1.53853 6.31708L9.24567 9.83161C9.48 9.9385 9.73455 9.99381 9.99211 9.99381C10.2497 9.99381 10.5042 9.9385 10.7385 9.83161L18.4637 6.32607Z"
                  stroke="#2C394B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span className="text-xs font-semibold">
                {convertEnglishToBangla(item?.total_enrolled)} জন জয়েন করেছে
              </span>
            </div>
          )}

          <div className="flex justify-between items-center font-ador mt-2">
            <div className="flex gap-3 items-center">
              {item?.course?.no_of_lesson && (
                <div className="flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="18"
                    viewBox="0 0 15 18"
                    fill="none"
                  >
                    <path
                      d="M1 15.2188V3.03125C1 2.49253 1.21401 1.97587 1.59494 1.59494C1.97587 1.21401 2.49253 1 3.03125 1H13.1875C13.403 1 13.6097 1.0856 13.762 1.23798C13.9144 1.39035 14 1.59701 14 1.8125V16.4375C14 16.653 13.9144 16.8597 13.762 17.012C13.6097 17.1644 13.403 17.25 13.1875 17.25H3.03125C2.49253 17.25 1.97587 17.036 1.59494 16.6551C1.21401 16.2741 1 15.7575 1 15.2188ZM1 15.2188C1 14.68 1.21401 14.1634 1.59494 13.7824C1.97587 13.4015 2.49253 13.1875 3.03125 13.1875H14M5.0625 7.5H9.9375"
                      stroke="#2C394B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span className="text-xs font-semibold">
                    {convertEnglishToBangla(item?.course?.no_of_lesson)}+ লেসন্স
                  </span>
                </div>
              )}

              {!!item?.course?.no_of_project && (
                <div className="flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                  >
                    <path
                      d="M11.8888 3.33331L10.0113 1.45577C9.71961 1.16403 9.32401 1.00009 8.91149 1H2.55554C2.14299 1 1.74733 1.16389 1.45561 1.45561C1.16389 1.74733 1 2.14299 1 2.55554V14.9999C1 15.4124 1.16389 15.8081 1.45561 16.0998C1.74733 16.3915 2.14299 16.5554 2.55554 16.5554H11.8888C12.3014 16.5554 12.697 16.3915 12.9887 16.0998C13.2805 15.8081 13.4443 15.4124 13.4443 14.9999M4.11109 13.4443H4.88886M14.5161 9.2646C14.8259 8.95477 15 8.53455 15 8.09639C15 7.65822 14.8259 7.238 14.5161 6.92817C14.2063 6.61834 13.7861 6.44428 13.3479 6.44428C12.9097 6.44428 12.4895 6.61834 12.1797 6.92817L9.06082 10.0486C8.87591 10.2334 8.74055 10.4618 8.66727 10.7128L8.01628 12.945C7.99676 13.0119 7.99559 13.0829 8.01289 13.1504C8.03019 13.2179 8.06533 13.2796 8.11462 13.3289C8.16392 13.3782 8.22556 13.4133 8.29309 13.4306C8.36062 13.4479 8.43157 13.4468 8.49849 13.4272L10.7307 12.7762C10.9817 12.703 11.2101 12.5676 11.3949 12.3827L14.5161 9.2646Z"
                      stroke="#2C394B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span className="text-xs font-semibold">
                    {Number(item?.course?.no_of_project).toLocaleString("bn")}+
                    প্রজেক্ট
                  </span>
                </div>
              )}
            </div>

            <button className="rounded-lg px-2 py-1 bg-[#F72568] text-white flex gap-1 items-center hind-siliguri">
              <span className="text-base font-semibold">বিস্তারিত</span>
              <span>
                <LuMousePointerClick className="w-4 h-auto" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
